if (!customElements.get("section-bundle-banner")) {
  customElements.define(
    "section-bundle-banner",
    class SectionBundleBanner extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.jumpButtons = this.querySelectorAll("[data-to]");
        this.jumpButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const anchor = document.querySelector(
              `[data-anchor="${button.getAttribute("data-to")}"]`
            );
            anchor.scrollIntoView({ behavior: "smooth" });
          });
        });
      }
    }
  );
}
